<template>
    <section v-if="records.length" class="flex flex-col gap-4">
        <h2 class="font-title text-base leading-4 font-extrabold uppercase">
            {{ $t('statistics.personal_records') }}
        </h2>
        <div class="flex flex-col gap-2">
            <Panel
                v-for="(record, index) in records"
                :key="index"
                size="full"
                padding="p-4"
                :corners="false"
                class="overflow-hidden"
                data-testid="personal-record"
            >
                <img
                    src="@/assets/images/statistics/record-pattern.svg"
                    alt=""
                    aria-hidden="true"
                    class="pointer-events-none absolute -top-4 -right-4 size-[94px] max-w-none opacity-60"
                />
                <div class="relative flex flex-col gap-4 tracking-[0.25px]">
                    <div class="flex items-center justify-between gap-4">
                        <span class="text-base leading-6 font-black uppercase">{{
                            record.title
                        }}</span>
                        <span class="flex size-6 shrink-0 items-center justify-center">
                            <svg
                                width="15"
                                height="19"
                                viewBox="0 0 15 19"
                                fill="none"
                                aria-hidden="true"
                            >
                                <path
                                    d="M10.1338 14C10.1338 11.6975 7.63506 10.253 5.63281 11.4072C4.70461 11.9424 4.13379 12.9312 4.13379 14C4.1338 16.3025 6.63253 17.747 8.63477 16.5928C9.56296 16.0576 10.1338 15.0688 10.1338 14ZM7.13379 12C7.70902 12 8.20048 12.2776 8.52832 12.6055C8.85616 12.9333 9.13379 13.4248 9.13379 14C9.13379 14.5752 8.85616 15.0667 8.52832 15.3945C8.20048 15.7224 7.70903 16 7.13379 16C6.55855 16 6.0671 15.7224 5.73926 15.3945C5.45246 15.1077 5.20416 14.6957 5.14648 14.2119L5.13379 14L5.14648 13.7881C5.20415 13.3043 5.45245 12.8923 5.73926 12.6055C6.0671 12.2776 6.55856 12 7.13379 12ZM2.26758 2.96875L5.81641 9.17871C6.70581 8.93188 7.6118 8.94781 8.4502 9.17969L12 2.96875L11.5156 2H2.75195L2.26758 2.96875ZM12.1338 14C12.1338 15.7849 11.1797 17.4334 9.63281 18.3252C6.30177 20.2452 2.1338 17.8466 2.13379 14C2.13379 12.4609 2.84318 11.0235 4.03027 10.085L0 3.03125L1.51562 0H12.752L14.2676 3.03125L10.2363 10.085C11.3698 10.9758 12.1338 12.3546 12.1338 14Z"
                                    :fill="medalColors[index]"
                                />
                            </svg>
                        </span>
                    </div>
                    <div class="flex items-center justify-between gap-4 text-sm leading-5">
                        <div class="flex min-w-0 items-center gap-2">
                            <template v-for="(detail, detailIndex) in record.details" :key="detail">
                                <img
                                    v-if="detailIndex > 0"
                                    src="@/assets/images/statistics/divider.svg"
                                    alt=""
                                    class="size-6 shrink-0"
                                />
                                <span class="truncate">{{ detail }}</span>
                            </template>
                        </div>
                        <span class="text-titles shrink-0">{{
                            formatPlayedAt(record.playedAt)
                        }}</span>
                    </div>
                </div>
            </Panel>
        </div>
    </section>
</template>

<script>
import Panel from '@/components/layout/Panel.vue'

export default {
    name: 'PersonalRecords',
    components: {
        Panel,
    },
    props: {
        records: {
            type: Array,
            required: true,
        },
    },
    computed: {
        medalColors() {
            return ['#D4AF37', '#C0C0C0', '#CD7F32']
        },
    },
    methods: {
        formatPlayedAt(playedAt) {
            const date = new Date(playedAt)
            const startOfDay = (day) => new Date(day.getFullYear(), day.getMonth(), day.getDate())
            const days = Math.round((startOfDay(new Date()) - startOfDay(date)) / 86400000)

            if (days <= 0) {
                return this.$t('statistics.today')
            }
            if (days < 7) {
                return this.$t('statistics.days_ago', { count: days })
            }
            if (days < 28) {
                return this.$t('statistics.weeks_ago', { count: Math.floor(days / 7) })
            }

            const pad = (value) => String(value).padStart(2, '0')
            return `${pad(date.getDate())} / ${pad(date.getMonth() + 1)}`
        },
    },
}
</script>
